module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_8004.13cc1478.png";